import { OrderByEnum } from '@oranta-mis/sdk';
import { TranslocoHelper } from '@core/helpers/transloco.helper';
import { TableColumn, TableColumnTypeEnum } from '@oranta-mis/ui-library';

export const patientListColumnHeader = (i18n: TranslocoHelper): TableColumn[] => [
  { type: TableColumnTypeEnum.person, key: 'person', name: i18n.tr('patient') },
  {
    type: TableColumnTypeEnum.text,
    key: 'created_at',
    name: i18n.tr('created_at'),
    sort: { sortable: true, orderBy: OrderByEnum.desc },
  },
];
